import { get } from 'lodash/fp';
import { useMemo } from 'react';
import { BankIntegrationProvider } from '../../../../../../api/types';
import useValidator from '../../../../../../utilities/useValidator';
import validators from '../../../../../../utilities/validators';
import { createBankIntegrationValidator } from '../../../../BankDetailsPage/BankForm/useBankIntegrationFormValidation';

const useBankIntegrationValidator = (integrationProvider?: BankIntegrationProvider, isUpdate = false) => {
    const validator = useMemo(
        () =>
            validators.compose(
                validators.requiredNonEmptyString('displayName'),
                validators.requiredString('identifier'),
                validators.requiredString('dealerCode'),

                validators.only(
                    values =>
                        (get('integrationProvider', values) ?? integrationProvider) === BankIntegrationProvider.Email,
                    validators.nest(
                        'integrationSettings.email',
                        createBankIntegrationValidator(BankIntegrationProvider.Email, isUpdate)
                    )
                ),

                validators.only(
                    values =>
                        (get('integrationProvider', values) ?? integrationProvider) === BankIntegrationProvider.Hlf,
                    validators.nest(
                        'integrationSettings.hlf',
                        createBankIntegrationValidator(BankIntegrationProvider.Hlf, isUpdate)
                    )
                ),

                validators.only(
                    values =>
                        (get('integrationProvider', values) ?? integrationProvider) === BankIntegrationProvider.Hlfv2,
                    validators.nest(
                        'integrationSettings.hlfV2',
                        createBankIntegrationValidator(BankIntegrationProvider.Hlfv2, isUpdate)
                    )
                ),

                validators.only(
                    values =>
                        (get('integrationProvider', values) ?? integrationProvider) === BankIntegrationProvider.Uob,
                    validators.nest(
                        'integrationSettings.uob',
                        createBankIntegrationValidator(BankIntegrationProvider.Uob, isUpdate)
                    )
                ),

                validators.only(
                    values =>
                        (get('integrationProvider', values) ?? integrationProvider) === BankIntegrationProvider.BmwFs,
                    validators.nest(
                        'integrationSettings.bmwFs',
                        createBankIntegrationValidator(BankIntegrationProvider.BmwFs, isUpdate)
                    )
                ),

                validators.only(
                    values =>
                        (get('integrationProvider', values) ?? integrationProvider) === BankIntegrationProvider.Maybank,
                    validators.nest(
                        'integrationSettings.maybank',
                        createBankIntegrationValidator(BankIntegrationProvider.Maybank, isUpdate)
                    )
                ),

                validators.only(
                    values =>
                        (get('integrationProvider', values) ?? integrationProvider) === BankIntegrationProvider.Enbd,
                    validators.nest(
                        'integrationSettings.enbd',
                        createBankIntegrationValidator(BankIntegrationProvider.Enbd, isUpdate)
                    )
                )
            ),
        [isUpdate, integrationProvider]
    );

    return useValidator(validator);
};

export default useBankIntegrationValidator;
